import { render } from "./Error500.vue?vue&type=template&id=7c23035e&scoped=true&ts=true"
import script from "./Error500.vue?vue&type=script&lang=ts"
export * from "./Error500.vue?vue&type=script&lang=ts"

import "./Error500.vue?vue&type=style&index=0&id=7c23035e&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Workspace/SushiEden/SushiEden.Admin.Vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c23035e"]])

export default __exports__